// extracted by mini-css-extract-plugin
module.exports = {"section1Container":"Section1_section1Container__kmXJA","itemContainer":"Section1_itemContainer__AEQEX","itemRow":"Section1_itemRow__bmccd","item":"Section1_item__p_VHC"};